<template>
    <div class="account">
        <v-flex class="center-me" xs12>
            <div class="header">
              <h1 style="margin-bottom: 0; padding: 0;">Welcome <mark>{{currentUser.displayName}}</mark>,<br> to Routine your personal overview of recurring routine tasks.
              <br><br>
              <h5 style="font-weight: 400; margin-top: 0; font-size: 1.2rem">You are logged in with {{currentUser.email}} and using Version {{appVersion}}.</h5>
              </h1>
            </div>

        </v-flex>
        <l-settings />
        <div class="d-flex justify-center mt-8">
                <v-btn height="44" width="180" class="main mb-5" @click="logout">
                  Logout
                </v-btn>
        </div>
    </div>
</template>

<script>
import lSettings from '@/components/settings'
import { mapState } from "vuex";
import {auth} from '@/firebase/async-firestore'

export default {
  components: {
    lSettings
  },
    data() {
        return {

        }
    },
    computed: {
      ...mapState("user", ["userProfile", "currentUser"]),
      ...mapState("app", ["appVersion"]),
    },
    methods: {
      async logout() {
        (await auth())
          .signOut()
          .then(() => {
            this.$router.push("/login");
          })
          .catch(err => {
            console.log(err);
          });
      },
    }
}
</script>


<style>
.account {
  height: 108%;
}
.version {
  position: absolute;
  bottom: 30%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.header {
  text-align: left;
  display: flex;
  padding: 6px 10px;
}
.header h1 {
  font-size: 1.33rem;
  line-height: 1.3;
  font-weight: 500;
  color: #F2F2F2;
}
.header mark {
  font-size: 1.33rem;
  color: #FFBD2E;
  background: none;
}

@media screen and (min-width: 1200px) {
   .header mark,
  .header h1 {
    font-size: 1.8rem;
  }
  .header h5 {
    font-size: 1.3rem !important;
  }
  .header {
    display: flex;
    justify-content: center;
    width: 52%;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .header mark,
  .header h1 {
    font-size: 1.8rem;
  }
  .header h5 {
    font-size: 1.3rem !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .account {
    height: 100%;
  }
  .header mark,
  .header h1 {
    font-size: 1.8rem;
  }
  .header h5 {
    font-size: 1.3rem !important;
  }
  .account .center-me {
    display: flex;
    align-items: flex-start !important;
  }
}
</style>